"use client";

// Core
import { Link } from "@/i18n/navigation";
import { useTranslations } from "next-intl";
import Image from "next/image";
import cx from "classnames";

// Definitions
import { ProviderType } from "@/domains/providers/types";

// Utils
import styles from "./index.module.scss";
import { PUBLIC_IMAGE_URL } from "@/network/http-config";
import { routes } from "@/definitions/book";

export interface ProviderCardProps {
  item: ProviderType;
  inSlide?: boolean;
}

export default function ProviderCard({ item, inSlide }: ProviderCardProps) {
  const t = useTranslations("ProviderCard");

  const cardStyles = cx(styles.card, { ...(inSlide && { [styles.in_slide]: inSlide }) });
  return (
    <article className={cardStyles}>
      <div className={styles.card__header}>
        <div className={styles.logo}>
          <picture>
            <source media="(min-width: 1025px)" srcSet={`${PUBLIC_IMAGE_URL}${item.image}`} />

            <Image
              className={styles.logo__img}
              src={`${PUBLIC_IMAGE_URL}${item.image}`}
              alt={item.name}
              width={160}
              height={64}
              loading="lazy"
            />
          </picture>
        </div>

        <h1 className={styles.card__title} aria-label={item.name}>
          {item.name}
        </h1>
      </div>

      <div className={styles.counter}>
        <div className={styles.counter__title}>{t("counter")}</div>
        <div className={styles.counter__value}>{item.countGames}</div>
      </div>

      <Link prefetch className={styles.link} href={`${routes.provider}/${item.slug}`}></Link>
    </article>
  );
}
